module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "description"
  }, [_c('MentoringHeader', [_vm._v("Наставничество")]), _c('div', {
    staticClass: "description__block"
  }, [_c('MentoringIcon'), _c('p', {
    staticClass: "description__text"
  }, [_vm._v("Модуль «Наставничество» предназначен для реализации программ наставничества — помощи школьникам,\nучителям, студентам в решении разного рода проблем более опытными товарищами.")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6dd23788","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/description/MentoringDescription.vue
// module id = df5bdc8252c842171f49
// module chunks = 89